import { MatrixClient } from 'matrix-js-sdk/src/matrix';
import { useEffect, useSyncExternalStore } from 'react';

import soundMuteStore from 'hooks/useSoundMutedRoomIds/soundMuteStore';

const useSoundMutedRoomIds = (matrixClient: MatrixClient): Set<string> => {
  useEffect(() => {
    soundMuteStore.hydrate(matrixClient);
  }, [matrixClient]);

  return useSyncExternalStore(soundMuteStore.subscribe, soundMuteStore.getSnapshot, soundMuteStore.getSnapshot);
};

export default useSoundMutedRoomIds;
